import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Add } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { FadingTooltip } from '../../../../../../ui';
import { CreateDataStoreItemWizard } from './components/CreateDataStoreItemWizard';

export const CreateDataStoreItemButton = ({ disabled }) => {
  const { t } = useTranslation();
  const [isCreationWizardOpen, setIsCreationWizardOpen] = useState(false);
  const handleCloseDialog = useCallback(() => {
    setIsCreationWizardOpen(false);
  }, [setIsCreationWizardOpen]);

  const tooltipTitle = disabled
    ? t(
        'commoncomponents.datastore.create.noPermissionTooltip',
        "You don't have permission to create a datastore. Please contact your administrator."
      )
    : t('commoncomponents.datastore.create.tooltip', 'Create a datastore.');

  return (
    <>
      <FadingTooltip title={tooltipTitle}>
        <span>
          <IconButton
            color="primary"
            onClick={() => setIsCreationWizardOpen(true)}
            disabled={disabled}
            data-cy="create-dataset-button"
            sx={{ height: '100%' }}
          >
            <Add fontSize="large" />
          </IconButton>
        </span>
      </FadingTooltip>
      <CreateDataStoreItemWizard open={isCreationWizardOpen} closeDialog={handleCloseDialog} />
    </>
  );
};

CreateDataStoreItemButton.propTypes = {
  disabled: PropTypes.bool,
};

CreateDataStoreItemButton.defaultProps = {
  disabled: false,
};
